import axios from '@axios';
import HelperService from '@/services/HelperService';

const baseUrl = 'api/v1/social-visits/bans';
const helperService = new HelperService();

export default {
  getVisitorSocialBans(visitorId) {
    return axios.get(`${baseUrl}/user/${visitorId}`);
  },
  removeVisitorSocialBan(banId) {
    return axios.delete(`${baseUrl}/delete/${banId}`);
  },
  createSocialBan(banData) {
    return axios.post(`${baseUrl}/create`, banData);
  },
  getSocialBansPaginated(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseUrl}/paginated${queryString}`);
  },
};
